import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from 'src/app/http.service';
import { ImageUploaderComponent } from 'src/app/image-uploader/image-uploader.component';

@Component({
  selector: 'app-api-game-management-form',
  templateUrl: './api-game-management-form.component.html',
  styleUrls: ['./api-game-management-form.component.scss']
})
export class ApiGameManagementFormComponent {

  public data: any = {status: 1}
  public providers:any = [];
  public provider_categories:any = []
  public categories:any = []
  public games:any = []
  public permission:any = {};
  private game_uuid:any;

  // "Direct entry" tile: instead of dropping the player on a grid of every game in the
  // provider+category, the tile launches ONE specific game directly. We store that as
  // type = "<provider-category>#<gameId>". The picker (direct_games) is fetched live from
  // the supplier so the admin can choose which game.
  public direct_entry:boolean = false;
  public direct_game_id:any = null;
  public direct_games:any = [];
  public direct_loading:boolean = false;
  public direct_error:string = "";

  @ViewChild('f') f : NgForm
  @ViewChild("imageUploader", {static: true}) imageUploader : ImageUploaderComponent;

  constructor(private http: HttpService, private route: ActivatedRoute) { 
    const uuid: Observable<string> = this.route.params.pipe(map(p => p['uuid']));
    this.permission = this.http.getSelecetdCompanyDetail();

    
    (async () => {
      await this.getGames();
      await this.initGamesCategory();
  
      uuid.subscribe(val => {
        if(val) {
          this.init(val)
          this.game_uuid = val;
        }
      })
    })()
    
  }

  async init(uuid) {
    this.data = await this.http.post('/admin/setting/seemless-game/detail/get', {uuid});

    if(this.data.image) {
      this.imageUploader.files = [this.data.image]
    }

    // A stored "<type>#<gameId>" tile is a direct-entry tile. Split the selector back out
    // so the provider-category ng-select matches the base type, the checkbox reflects the
    // saved state, and the picker pre-selects the saved game.
    if (this.data.type && String(this.data.type).indexOf('#') !== -1) {
      const t = String(this.data.type);
      const idx = t.indexOf('#');
      this.direct_game_id = t.slice(idx + 1);
      this.data.type = t.slice(0, idx);
      this.direct_entry = true;
    }

    this.checkIfCurrentProviderHaveCategory();

    if (this.direct_entry) {
      this.loadDirectGames();
    }

  }

  async getGames() {
    this.providers = await this.http.post("/admin/setting/seemless-game/get");
  }

  async initGamesCategory() {
    this.categories = await this.http.post("/admin/app/game/category/init");
  }

  checkIfCurrentProviderHaveCategory() {

    if(!this.data.api_id) {
      return;
    }

    let y = this.providers.find((v:any) => {
      return v.id == this.data.api_id
    })

    this.provider_categories = y.available;

  }

  // Switching provider resets the direct-entry picker (the old game ids belong to the old
  // provider). Keep the checkbox state; the admin re-picks after choosing a category.
  onProviderChange() {
    this.checkIfCurrentProviderHaveCategory();
    this.direct_game_id = null;
    this.direct_games = [];
    this.direct_error = "";
    if (this.direct_entry) {
      this.loadDirectGames();
    }
  }

  // Picking a different provider-category invalidates the chosen game; reload the picker.
  onProviderCategoryChange() {
    this.direct_game_id = null;
    this.direct_games = [];
    this.direct_error = "";
    if (this.direct_entry) {
      this.loadDirectGames();
    }
  }

  onDirectEntryChange(checked:boolean) {
    this.direct_entry = checked;
    if (checked) {
      this.loadDirectGames();
    } else {
      this.direct_game_id = null;
      this.direct_games = [];
      this.direct_error = "";
    }
  }

  async loadDirectGames() {
    if (!this.data.api_id || !this.data.type) {
      this.direct_games = [];
      return;
    }
    this.direct_loading = true;
    this.direct_error = "";
    try {
      let rtn:any = await this.http.post('/admin/setting/seemless-game/catalog/get', {
        api_id: this.data.api_id,
        type: this.data.type,
      });
      if (rtn && rtn.status === false) {
        this.direct_games = [];
        this.direct_error = rtn.message || "Could not load games for this provider.";
      } else {
        this.direct_games = (rtn && rtn.games) ? rtn.games : [];
        if (this.direct_games.length === 0) {
          this.direct_error = "No selectable games returned by the provider.";
        }
      }
    } catch (e) {
      this.direct_games = [];
      this.direct_error = "Could not load games for this provider.";
    }
    this.direct_loading = false;
  }

  async submit(stay = false) {
    // Compose the stored type: "<provider-category>#<gameId>" for a direct-entry tile,
    // or just "<provider-category>" otherwise. Build a payload copy so the on-screen
    // ng-select keeps binding to the base type.
    const payload = { ...this.data };
    if (this.direct_entry && this.direct_game_id) {
      payload.type = this.data.type + '#' + this.direct_game_id;
    }

    let rtn:any = await this.http.post('/admin/setting/seemless-game/detail/update', payload);

    if(stay) {
      return;
    }

    if (rtn.uuid) {
      this.http.navigate(['/lo',this.http.getStaticSelectedCompany(),'api-game-setting', 'form', rtn.uuid])
      return;
    }
    
    this.direct_entry = false;
    this.direct_game_id = null;
    this.direct_games = [];
    this.direct_error = "";
    await this.f.resetForm({status: 1});
  }

  async upload(v:any) {
    this.data.image = v[0];
  }

  removeImage() {

    if(!this.game_uuid) {
      return;
    }

    delete this.data.image;
    this.submit(true);
  }

}
